import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/view/components/ui/form'
import { Input } from '@/view/components/ui/input'
import { UseFormReturn } from 'react-hook-form'
import { BannerFormValues } from '../../useBannerForm'

interface FormFieldLinkProps {
  form: UseFormReturn<BannerFormValues>
  target?: string
}

export const FormFieldLink = ({
  form,
  target = 'banner',
}: FormFieldLinkProps) => (
  <FormField
    control={form.control}
    name="link"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Link</FormLabel>
        <FormControl>
          <Input placeholder="https://" {...field} />
        </FormControl>
        <FormDescription>
          Insira o endereço que o usuário será redirecionado ao clicar no
          {` ${target}`}
        </FormDescription>
        <FormMessage />
      </FormItem>
    )}
  />
)
